import SearchComponent from '@components/Default/Search/SearchComponent';
import Page from '@components/Page';
import TableComponent, { ITableColumn } from '@components/TableComponent';
import React from 'react';

interface StateType {
    search: string;
    tableData: any;
}
interface PropType {
}


export default class ClientContainer extends React.Component<PropType,StateType> {
    constructor(props: PropType) {
        super(props);
        
        
        this.state = {
            search: "",
            tableData : [{name:"Rafa", id:"data1", createdAt:"12-07-1994", action:"Desabilitar"}, {name:"data2", id:"data2", createdAt:"12-07-1994", canBeDisabled: true}, 
            {name:"Joao", id:"data3", createdAt:"12-07-1994", action:"Desabilitar"}, {name:"data4", id:"data4", createdAt:"12-07-1994", action:"Desabilitar"} , 
            {name:"Morcego", id:"data5", createdAt:"12-07-1994", action:"Desabilitar"} , {name:"data6", id:"data6", createdAt:"12-07-1994", action:"Desabilitar"}]
        };
    
    }    
    
    getInitialTableColumns = (): ITableColumn[] => {
        return [{
            title: 'table.users.name',
            dataIndex: 'name',
            key: 'name',
            width: 225
        },
        {
            title: 'id',
            dataIndex: 'id',
            key: 'id',
            width: 225
        },
        {
            title: 'table.products.createdAt',
            dataIndex: 'createdAt',
            key: 'createdAt',
            width: 225
        },
        {
            title: 'table.actions',
            dataIndex: 'action',
            key: 'action',
            width: 225
        }] as ITableColumn[];
    };
    
    disableClient = async () => {
        
    }
    
    setTableData = async () => {

        let found = [''];
        found.shift();
        for(let key of this.state.tableData){
            if(key.name.indexOf(this.state.search) > -1){
                console.log(key.name);
                found = found.concat(key);
            }
        }
        this.setState({
            tableData: found
        })
    }
    
    searchData = async (event: any) => {
        event.preventDefault();
        await this.setState({
            search: event.target.find.value
        })
        return this.setTableData();
    }
    render() {
        console.log("TableData  = ", this.state.tableData)
        let tableColumns = this.getInitialTableColumns();
        return (
            <Page>
                    <div className='goepik-component-tablesize'>
                        <SearchComponent
                          onSubmit={this.searchData}
                          placeholder='form.placeholders.usersSearch'
                          defaultValue={this.state.search}
                          buttonText='form.buttons.search'
                        />
                      </div>
                    <div className={'goepik-component-tablesize'} >
                        <TableComponent 
                            columns={tableColumns}
                            data={this.state.tableData}
                            showConfirmationModal={false}
                            onEdit={this.setTableData}
                            onActive={this.disableClient}
                        />
                    </div>
            </Page>
        )
    }

}

